export default "__VITE_ASSET__CV0mK2Ay__"